<form [formGroup]="form">
	<div class="row">
		<div class="col-name-input col-sm-5 mb-2 ps-2">
			<label for="firstName" class="form-label mb-0">First Name<span class="text-danger" *ngIf="!isReadOnly"> * </span></label>
			<input type="text" class="form-control mm-default-text mt-0" id="firstName"
			       formControlName="firstName" data-identifier="universal-id-first-name" required [readOnly]="isReadOnly"
			       [ngClass]="{'is-invalid': form.controls['firstName'].invalid && (form.controls['firstName'].dirty || !form.controls['firstName'].untouched), 'readonly': isReadOnly}">
			<div *ngIf="form.controls['firstName']?.invalid && (form.controls['firstName']?.dirty || !form.controls['firstName'].untouched)">
				<div *ngIf="form.controls['firstName']?.hasError('required')" class="text-danger">
					First Name is required.
				</div>
				<div *ngIf="form.controls['firstName']?.hasError('maxlength')" class="text-danger">
					First Name can not be longer than 100 characters.
				</div>
				<div *ngIf="form.controls['firstName']?.hasError('pattern')" class="text-danger">
					First Name is not valid.
				</div>
			</div>
		</div>

		<div class="col-name-input col-sm-5 mb-2 ps-0">
			<label for="lastName" class="form-label mb-0">Last Name<span class="text-danger" *ngIf="!isReadOnly"> * </span></label>
			<input type="text" class="form-control mm-default-text mt-0" id="lastName"
			       formControlName="lastName" data-identifier="universal-id-last-name" required [readOnly]="isReadOnly"
			       [ngClass]="{'is-invalid': form.controls['lastName'].invalid && (form.controls['lastName'].dirty || !form.controls['lastName'].untouched), 'readonly': isReadOnly}">
			<div *ngIf="form.controls['lastName'].invalid && (form.controls['lastName'].dirty || !form.controls['lastName'].untouched)">
				<div *ngIf="form.controls['lastName']?.hasError('required')" class="text-danger">
					Last Name is required.
				</div>
				<div *ngIf="form.controls['lastName']?.hasError('maxlength')" class="text-danger">
					Last Name can not be longer than 100 characters.
				</div>
				<div *ngIf="form.controls['lastName']?.hasError('pattern')" class="text-danger">
					Last Name is not valid.
				</div>
			</div>
		</div>
		<div class="col-dob-input col-sm-2 mb-2 ps-0">
			<label for="dateOfBirth" class="form-label mb-0">Date of Birth<span class="text-danger" *ngIf="!isReadOnly && dobRequired"> * </span></label>
			<lib-mm-datepicker
					[placeholder]="'mm/dd/yyyy'"
					[required]="dobRequired"
					[minDate]="dateOfBirthMin"
					[maxDate]="dateOfBirthMax"
					[isInvalid]="form.controls['dateOfBirth'].invalid && (form.controls['dateOfBirth'].dirty || !form.controls['dateOfBirth'].untouched)"
                    id="dateOfBirth"
					data-identifier="universal-id-date-of-birth"
					formControlName="dateOfBirth">
			</lib-mm-datepicker>
			<div *ngIf="form.controls['dateOfBirth'].invalid && (form.controls['dateOfBirth'].dirty || !form.controls['dateOfBirth'].untouched)">
				<div *ngIf="dobRequired && form.controls['dateOfBirth']?.hasError('required')" class="text-danger">
					Date of Birth is required.
				</div>
				<div *ngIf="form.controls['dateOfBirth']?.hasError('badDate')" class="text-danger">
					Date of Birth is not a valid date.
				</div>
				<div *ngIf="form.controls['dateOfBirth']?.hasError('beforeMinDate')" class="text-danger">
					Date of Birth cannot be
					before {{ form.controls['dateOfBirth'].errors?.['beforeMinDate']?.minDate }}
				</div>
				<div *ngIf="form.controls['dateOfBirth']?.hasError('afterMaxDate')" class="text-danger">
					Date of Birth cannot be
					after {{ form.controls['dateOfBirth'].errors?.['afterMaxDate']?.maxDate }}
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-4 mb-2 ps-2">
			<label for="username" class="form-label mb-0">{{ enterpriseLabels.universalIdLabel }} Username<span class="text-danger" *ngIf="!isReadOnly"> * </span></label>
			<input type="text" class="form-control mm-default-text mt-0" id="username"
			       formControlName="username" data-identifier="universal-id-username" required [readOnly]="isReadOnly" [mmInputTrim]="isCreateMode"
			       [ngClass]="{'is-invalid': form.controls['username'].invalid && (form.controls['username'].dirty || !form.controls['username'].untouched), 'readonly': isReadOnly}">
			<div *ngIf="form.controls['username']?.invalid && (form.controls['username']?.dirty || !form.controls['username'].untouched)">
				<div *ngIf="form.controls['username']?.hasError('required')" class="text-danger">
					Username is required.
				</div>
				<div *ngIf="form.controls['username']?.hasError('maxlength')" class="text-danger">
					Username can not be longer than {{form.controls['username']?.errors?.['maxlength']?.requiredLength}} characters.
				</div>
				<div *ngIf="form.controls['username']?.hasError('existingValue')" class="text-danger">
					Username is already registered in the system.
				</div>
			</div>
		</div>
		<div class="col-sm-4 mb-2 ps-0">
			<label for="email" class="form-label mb-0">Email Address<span class="text-danger" *ngIf="!isReadOnly && emailRequired"> * </span></label>
			<input type="text" class="form-control mm-default-text mt-0" id="email"
			       formControlName="email" data-identifier="universal-id-email" [required]="emailRequired" [readOnly]="isReadOnly"
			       [ngClass]="{'is-invalid': form.controls['email'].invalid && (form.controls['email'].dirty || !form.controls['email'].untouched), 'readonly': isReadOnly}">
			<div *ngIf="form.controls['email']?.invalid && (form.controls['email']?.dirty || !form.controls['email'].untouched)">
				<div *ngIf="emailRequired && form.controls['email']?.hasError('required')" class="text-danger">
					Email Address is required.
				</div>
				<div *ngIf="form.controls['email']?.hasError('maxlength')" class="text-danger">
					Email Address can not be longer than 50 characters.
				</div>
				<div *ngIf="form.controls['email']?.hasError('email')" class="text-danger">
					The value entered is not a valid email address.
				</div>
				<div *ngIf="form.controls['email']?.hasError('emailDomainPolicy')" class="text-danger">
					<span class="text-danger">{{ emailError }}</span>
				</div>
				<div *ngIf="form.controls['email']?.hasError('existingValue')" class="text-danger">
					Email is already assigned to a {{ enterpriseLabels.universalIdLabel }}.
				</div>
			</div>
		</div>
		<div class="col-sm-4 mb-2 ps-0">
			<label for="phone" class="form-label mb-0">Phone Number<span class="text-danger" *ngIf="!isReadOnly"> * </span></label>
			<input type="text" class="form-control mm-default-text mt-0" id="phone"
			       formControlName="phone" data-identifier="universal-id-phone-number" required maxlength="50" [readOnly]="isReadOnly"
			       [ngClass]="{'is-invalid': form.controls['phone'].invalid && (form.controls['phone'].dirty || !form.controls['phone'].untouched), 'readonly': isReadOnly}">
			<div *ngIf="form.controls['phone']?.invalid && (form.controls['phone']?.dirty || !form.controls['phone'].untouched)">
				<div *ngIf="form.controls['phone']?.hasError('required')" class="text-danger">
					Phone Number is required.
				</div>
				<div *ngIf="form.controls['phone']?.hasError('minlength')" class="text-danger">
					Phone Number can not be smaller than 10 characters.
				</div>
				<div *ngIf="form.controls['phone']?.hasError('pattern')" class="text-danger">
					The value entered is not a valid phone number.
				</div>
			</div>
		</div>
	</div>
	<!-- passwordAllowed also re-checked on required/asterisk/error below: defense-in-depth, not redundant by accident -->
	<div class="row" *ngIf="!isReadOnly && passwordAllowed">
		<div class="col-sm-6 mb-2 ps-2">
            <label for="password" class="form-label mb-0">
               Password <span class="text-danger" *ngIf="isCreateMode && passwordAllowed">* </span>
               <fa-icon [icon]="faInfoCircle" [ngbTooltip]="passwordTooltipText" [container]="'body'" [placement]="'top'" *ngIf="!isCreateMode"></fa-icon>
            </label>
			<div class="input-container position-relative">
				<input #passwordInput type="password" class="form-control mm-default-text mt-0" id="password"
				       formControlName="password" data-identifier="universal-id-password" [required]="isCreateMode && passwordAllowed" autocomplete="off"
				       [ngClass]="{'is-invalid': form.controls['password'].invalid && (form.controls['password'].dirty || !form.controls['password'].untouched)}">
				<span class="password-icon position-absolute" id="passwordIconSpan" tabindex="0"
				      (click)="togglePassword(passwordInput, passwordIcon)" (keydown)="onKeydown()">
                      <i #passwordIcon id="passwordIcon" class="fa fa-solid fa-lg fa-eye"></i>
                </span>
			</div>
			<div *ngIf="form.controls['password']?.invalid && (form.controls['password']?.dirty || !form.controls['password'].untouched)">
				<div *ngIf="isCreateMode && passwordAllowed && form.controls['password']?.hasError('required')" class="text-danger">
					Password is required.
				</div>
				<div *ngIf="form.controls['password']?.hasError('passwordPattern')" class="text-danger">
					Password does not follow the guidelines:
                    <div *ngFor="let val of passwordError; trackBy: ('$index' | trackByProperty )">
                        <span class="text-danger">* {{ val }}</span>
                    </div>
				</div>
			</div>
		</div>
		<div class="col-sm-6 mb-2 ps-4">
			<label for="confirmPassword" class="form-label mb-0">
                Confirm Password<span class="text-danger" *ngIf="isCreateMode && passwordAllowed"> * </span>
            </label>
			<div class="input-container position-relative">
				<input #confirmPasswordInput type="password" class="form-control mm-default-text mt-0" id="confirmPassword"
				       formControlName="confirmPassword" data-identifier="universal-id-confirm-password" [required]="isCreateMode && passwordAllowed"
				       [ngClass]="{'is-invalid': form.controls['confirmPassword'].invalid && (form.controls['confirmPassword'].dirty || !form.controls['confirmPassword'].untouched)}">
				<span class="password-icon position-absolute" id="confirmPasswordIconSpan" tabindex="0"
				      (click)="togglePassword(confirmPasswordInput, confirmPasswordIcon)" (keydown)="onKeydown()">
                      <i #confirmPasswordIcon id="confirmPasswordIcon" class="fa fa-solid fa-lg fa-eye"></i>
                 </span>
			</div>
			<div *ngIf="form.controls['confirmPassword']?.invalid && (form.controls['confirmPassword']?.dirty || !form.controls['confirmPassword'].untouched)">
				<div *ngIf="isCreateMode && passwordAllowed && form.controls['confirmPassword']?.hasError('required')" class="text-danger">
					Confirm Password is required.
				</div>
				<div *ngIf="form.controls['confirmPassword']?.hasError('passwordMismatch')" class="text-danger">
					Passwords must match.
				</div>
			</div>
		</div>
	</div>

    <div class="row mt-2 mb-2" *ngIf="idpAttributes.length > 0 || ssoUserDetails?.externalIdpDto?.username">
        <hr class="ms-2">
        <span class="header-label mb-3 ps-2">
            3rd Party IDP
        </span>
        <div class="col-md-12 mb-2 ps-2" *ngIf="ssoUserDetails?.externalIdpDto?.username">
            <label for="external-id-name" class="form-label mb-0">
                SSO Username
            </label>
            <div class="d-flex align-items-center">
                <input id="external-id-name"
                       class="form-control mm-default-text mt-0 readonly"
                       type="text"
                       [readOnly]="true"
                       [value]="ssoUserDetails?.externalIdpDto?.username">
                <button *ngIf="ssoUserDetails?.externalIdpDto"
                        type="button"
                        class="btn btn-link ms-2"
                        (click)="unlinkExternalIdp()">
                    Unlink
                </button>
            </div>
        </div>
        <ng-container *ngFor="let attr of idpAttributes; let i = index">
            <div class="col-sm-4 mb-2" [ngClass]="{'ps-2': i % 3 === 0, 'ps-0': i % 3 !== 0}">
                <label [for]="'idp_' + attr.name" class="form-label mb-0">
                    {{ attr.description }}
                </label>
                <input [id]="'idp_' + attr.name"
                       class="form-control mm-default-text mt-0"
                       type="text"
                       [formControlName]="'idp_' + attr.name"
                       [attr.data-identifier]="'universal-id-idp-' + attr.name">
            </div>
        </ng-container>
    </div>

    <div class="row mt-2 mb-2">
        <hr class="ms-2">
        <span class="header-label mb-3 ps-2">
            Account Status
        </span>
        <div class="col-sm-12 mb-2 ps-2 d-flex align-items-center" *ngIf="isLocked">
            <input data-identifier="universal-id-status-unlock" type="checkbox" formControlName="unlock"
                   class="me-2 mt-0" id="unlockAccount">
            <label for="unlockAccount" class="mb-0">Unlock Account</label>
        </div>
        <div class="col-sm-12 mb-2 ps-2 d-flex align-items-center" *ngIf="!isEnterpriseAdminHidden">
            <input data-identifier="universal-id-org-admin" type="checkbox" formControlName="enterpriseAdmin"
                   class="me-2 mt-0" id="enterpriseAdmin">
            <label for="enterpriseAdmin" class="mb-0">Set as Organization Admin</label>
        </div>
    </div>

    <div *ngIf="!this.isCreateMode" class="row mt-2">
        <hr class="ms-2">
        <span class="header-label mb-3 ps-2">{{ enterpriseLabels.universalIdLabel }} Status</span>
        <div class="col-sm-12 mb-3 ps-2">
            <mmoa-universal-id-statuses [user]="ssoUserDetails"></mmoa-universal-id-statuses>
        </div>
    </div>
</form>
